import { render, staticRenderFns } from "./CustomAuthorsSelector.vue?vue&type=template&id=40ff8b97"
import script from "./CustomAuthorsSelector.vue?vue&type=script&lang=js"
export * from "./CustomAuthorsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports